"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPackageCourseGreenFeeForDate = void 0;
const dayjs = require("dayjs");
const getPackageCourseGreenFeeForDate = (date, course) => {
    let prices = course?.prices?.green_fees?.find((price) => {
        return (dayjs(date).unix() >= dayjs(price.from_date).unix() &&
            dayjs(date).unix() <= dayjs(price.to_date).unix());
    });
    if (!prices) {
        if (course?.prices?.green_fees?.length > 0) {
            prices = course?.prices?.green_fees[0];
        }
        else {
            return null;
        }
    }
    return prices;
};
exports.getPackageCourseGreenFeeForDate = getPackageCourseGreenFeeForDate;
